import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-inline-error',
  templateUrl: './inline-error.component.html',
  styleUrls: ['./inline-error.component.scss'],
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineErrorComponent {}
